/* eslint-disable react/no-array-index-key */
/* eslint-disable no-useless-escape */
import { FC } from 'react';
import { TMarkdownToHtmlConverterProps } from './types';
import { unEscapeMarkdown } from './utils';

export const MarkdownToHtmlConverter: FC<TMarkdownToHtmlConverterProps> = ({ markdownText }) => {
	const boldRegex = /(\*{1}[^*]+\*{1})/g;
	// const underlineRegex = /(=={1}[^_]+=={1})/g;
	// const italicRegex = /(_{1}[^_]+_{1})/g;
	const italicRegex = /_(?!\[[^\]]+\]\([^\)]+\))([^_]+)_(?!\[[^\]]+\]\([^\)]+\))/g;
	const italicRegex2 = /\+\+(?!\[[^\]]+\]\([^\)]+\))([^\+]+)\+\+(?!\[[^\]]+\]\([^\)]+\))/g;
	const underlineRegex = /__(?!\[[^\]]+\]\([^\)]+\))([^_]+)__(?!\[[^\]]+\]\([^\)]+\))/g;
	const underlineRegex2 = /==(?!\[[^\]]+\]\([^\)]+\))([^=]+)==(?!\[[^\]]+\]\([^\)]+\))/g;

	const strikethroughRegex = /(~{1}[^~]+~{1})/g;
	const linkRegex = /(\[[^\]]+\]\([^\)]+\))/g;
	const spoilerRegex = /(\|{2}[^||]+\|{2})/g;
	// const lineTranslation = /(\r\n|\n|\r)/gm;
	const lineTranslation = /(\n)/g;

	const escapedMarkdown = unEscapeMarkdown(markdownText).replace(/[<>&]/g, (tag: string) => {
		const tagsToReplace = (t: string) => {
			if (t === '<') return '&lt;';
			if (t === '>') return '&gt;';
			// if (t === '&') return '&amp;';
			return t;
		};
		return tagsToReplace(tag);
	});

	const replaceUnderline = (text: string) => {
		return text.replace(/__(?!\[\S+?\]\(\S+?\))([^_]+)__(?!\[\S+?\]\(\S+?\))/g, '==$1==');
	};

	const replaceItalic = (text: string) => {
		return text.replace(italicRegex, '++$1++');
	};

	const replaceLineTranslation = (text: string) => {
		return text.replace(/(\\n)/g, '');
	};

	const parts = escapedMarkdown
		.split(linkRegex)
		.map(part => {
			if (linkRegex.test(part)) {
				return part;
			}
			return replaceItalic(replaceUnderline(part));
		})

		.flatMap(part => part?.split(boldRegex))
		.flatMap(part => part?.split(strikethroughRegex))
		.flatMap(part => part?.split(spoilerRegex))
		.flatMap(part => part?.split(lineTranslation));
	// .flatMap((part) => part?.split(italicRegex))
	// .flatMap((part) => part?.split(underlineRegex));
	return (
		<div>
			{parts.map((part, index) => {
				if (part.match(linkRegex)) {
					const link = part.match(/\([^\)]+\)/g);
					const text = part.match(/\[[^\]]+\]/g);
					return (
						<a key={`parts${index}`} href={link ? link[0].replace(/\(|\)/g, '') : ''}>
							{text ? text[0].replace(/\[|\]/g, '') : ''}
						</a>
					);
				}

				if (part.match(boldRegex)) {
					return <b key={`parts${index}`}>{part.replace(/\*{1}/g, '')}</b>;
				}
				if (part.match(strikethroughRegex)) {
					return <s key={`parts${index}`}>{part.replace(/~{1}/g, '')}</s>;
				}
				if (part.match(spoilerRegex)) {
					return (
						<span key={`parts${index}`} className="spoiler">
							{part.replace(/\|{2}/g, '')}
						</span>
					);
				}
				if (part.match(lineTranslation)) {
					return <br key={`parts${index}`} />;
				}
				if (part.match(underlineRegex2)) {
					return <u key={`parts${index}`}>{part.replace(/=={1}/g, '')}</u>;
				}
				if (part.match(italicRegex2)) {
					return <i key={`parts${index}`}>{part.replace(/\+\+{1}/g, '')}</i>;
				}

				return replaceLineTranslation(part);
			})}
		</div>
	);
};
